(function (global) {
  'use strict';
  const labels = {
    trocken: 'Trocken', bruch: 'Strapaziert', fein: 'Fein & ohne Volumen', frizz: 'Frizz',
    locken: 'Lockig oder wellig', normal: 'Ausgeglichen / unsicher', natur: 'Naturhaar',
    gefaerbt: 'Gefärbt oder getönt', blondiert: 'Blondiert', gelbstich: 'Gelbstich',
    chemie: 'Chemisch umgeformt', unsicher: 'Unsicher', moisture: 'Feuchtigkeit',
    repair: 'Pflege für strapaziertes Haar', frizzSmoothing: 'Weniger Frizz', volume: 'Volumen',
    colorCare: 'Farbschutz', antiYellow: 'Gelbstich ausgleichen', curl: 'Locken definieren',
    stylingHold: 'Styling & Halt', hitzestyling: 'Föhn oder Glätteisen', finish: 'Stylingprodukte',
    wenig: 'Natürlich & unkompliziert', heatProtection: 'Hitzeschutz', cleansing: 'Reinigung',
  };
  const needs = {
    trocken: ['moisture'], bruch: ['repair'], fein: ['volume'], frizz: ['frizzSmoothing'],
    locken: ['curl'], normal: ['cleansing'], natur: [], gefaerbt: ['colorCare'],
    blondiert: ['repair'], gelbstich: ['antiYellow'], chemie: ['repair'], unsicher: [],
    hitzestyling: ['heatProtection'], finish: ['stylingHold'], wenig: [],
  };
  const groupRules = [
    ['cleansing', /shampoo|reinigung|cleansing/],
    ['conditioner', /conditioner|spulung|pflegespulung|balsam/],
    ['mask', /maske|mask\b|haarkur|treatment/],
    ['moisture', /feuchtigkeit|trocken|sprode|spr(o|oe)d|nahr|nahrend|argan|hydr|nutri|moistur/],
    ['repair', /repair|repar|keratin|protein|rekonstr|restruktur|regener|kraftlos|starkend|strapaziert|bond|plex/],
    ['frizzSmoothing', /frizz|glattung|glattende|glattendes|smooth|sleek/],
    ['volume', /volumen|volume|feines? haar|feinem haar|bodifying/],
    ['colorCare', /farbschutz|farberhalt|color save|color care|coloriertes|coloriertem|gefarbtes|gefarbtem/],
    ['antiYellow', /anti[- ]?gelb|gelbstich|silber|silver|no[- ]?yellow|anti[- ]?yellow/],
    ['curl', /locken|lockig|curl|wellig|wellen/],
    ['stylingHold', /haarspray|haargel|haarwachs|\bwachs\b|\bwax\b|pomade|fixierung|fixier|\bhalt\b|\bhold\b|styling|schaum|mousse/],
    ['heatProtection', /hitzeschutz|heat protection|thermoschutz/],
  ];
  const knownGroups = new Set(groupRules.map(([group]) => group));
  const roles = new Set(['Reinigung', 'Pflege', 'Hitzeschutz', 'Finish']);
  const rankOf = (product) => (Number.isFinite(product.rank) ? product.rank : Number.MAX_SAFE_INTEGER);
  const titleKey = (product) => normalize(product.title).replace(/[^a-z0-9]+/g, ' ').trim();
  function normalize(value) {
    return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ß/g, 'ss');
  }
  function productGroups(product) {
    // Groups from the catalog generator (title, product type, benefit tags)
    // stay valid when a title is reworded; the title rules are the fallback.
    if (Array.isArray(product.groups) && product.groups.length) {
      return product.groups.filter((group) => knownGroups.has(group));
    }
    // Product identity is stronger evidence than the legacy catch-all tags.
    const text = normalize(product.title);
    if (/entwickler|aktivator|activator|oxidations|blondierung|blondierpulver|dauerwell|farbentferner|cuticula|alkalin|neutralisator|neutralisierendes fixiermittel|glattungsmittel|glattungscreme|tonungscreme|tonungsfluid|haarf(a|ae)rb|\bhaarfarbe\b|farbcreme|color cream|colorcreme|permanent|\btoner\b/.test(text)) return [];
    if (product.caution === true && !/shampoo|maske|mask\b|conditioner|spulung|balsam|haarkur|haarol|pflegespray|hitzeschutz|haarspray|haarwachs|haargel/.test(text)) return [];
    return groupRules.filter(([, expression]) => expression.test(text)).map(([group]) => group);
  }
  function safeUrl(value) {
    const path = String(value || '');
    return /^\/products\/[a-z0-9][a-z0-9-]*\/?$/i.test(path) ? path : null;
  }
  function rankProducts(products, answers) {
    if (!answers.goal || !labels[answers.goal]) return [];
    const extra = Object.values(answers).flat().flatMap((value) => needs[value] || []);
    return products.map((product) => {
      const groups = productGroups(product);
      if (!safeUrl(product.url) || !groups.includes(answers.goal)) return null;
      if (groups.includes('antiYellow') && answers.goal !== 'antiYellow' && !(answers.treatment || []).includes('gelbstich')) return null;
      const named = Array.isArray(product.strong) && product.strong.includes(answers.goal) ? 3 : 0;
      return { ...product, groups, score: 100 + named - (product.bulk ? 6 : 0) + extra.reduce((sum, group) => sum + (groups.includes(group) ? 5 : 0), 0) };
    }).filter(Boolean).sort((a, b) => b.score - a.score || rankOf(a) - rankOf(b) || a.title.localeCompare(b.title, 'de'));
  }
  function productRole(product) {
    if (roles.has(product.role)) return product.role;
    const groups = productGroups(product);
    if (groups.includes('cleansing')) return 'Reinigung';
    if (groups.includes('conditioner') || groups.includes('mask') || /pflegelotion|ampull|haarol|serum|leave.in/.test(normalize(product.title))) return 'Pflege';
    if (groups.includes('heatProtection')) return 'Hitzeschutz';
    return 'Finish';
  }
  function selectProducts(products, limit = 3) {
    // Same product under two handles: show it once.
    const seen = new Set();
    const unique = products.filter((product) => {
      const keys = [product.url, titleKey(product)];
      if (keys.some((key) => seen.has(key))) return false;
      keys.forEach((key) => seen.add(key));
      return true;
    });
    const roles = new Set();
    const first = [];
    const alternatives = [];
    for (const product of unique) {
      const role = productRole(product);
      if (roles.has(role)) alternatives.push(product);
      else { roles.add(role); first.push(product); }
    }
    // A second care product helps more than a second shampoo.
    const preference = ['Pflege', 'Finish', 'Reinigung', 'Hitzeschutz'];
    const ordered = alternatives
      .map((product, index) => ({ product, index }))
      .sort((a, b) => preference.indexOf(productRole(a.product)) - preference.indexOf(productRole(b.product)) || a.index - b.index)
      .map(({ product }) => product);
    return [...first, ...ordered].slice(0, limit);
  }
  function resultSummary(answers) {
    const parts = [`Ausgewählt für dein Ziel: ${labels[answers.goal] || 'passende Pflege'}.`];
    if ((answers.state || []).includes('fein')) parts.push('Bei feinem Haar die Pflege sparsam dosieren.');
    else if ((answers.treatment || []).includes('blondiert')) parts.push('Blondierte Längen besonders schonend behandeln.');
    else if ((answers.styling || []).includes('hitzestyling')) parts.push('Beim Styling mit Hitze zusätzlich auf Hitzeschutz achten.');
    return parts.join(' ');
  }
  function routine(answers) {
    const result = ['Reinige dein Haar mit einem passenden Shampoo. Verteile die Pflege anschließend vor allem in Längen und Spitzen.'];
    const byGoal = {
      moisture: 'Nutze einen feuchtigkeitsspendenden Conditioner oder eine Maske nach Herstellerangabe. Beginne bei feinem Haar mit wenig Produkt.',
      repair: 'Wähle eine Pflege für strapaziertes Haar und reduziere belastende Hitze. Häufigkeit und Einwirkzeit richten sich nach dem Produkt.',
      frizzSmoothing: 'Verteile Anti-Frizz-Pflege sparsam in den Längen. Trockne das Haar schonend und vermeide kräftiges Trockenrubbeln.',
      volume: 'Wähle leichte Pflege und dosiere sie sparsam. Volumenprodukte kommen gezielt an den Ansatz oder in die vom Hersteller empfohlenen Haarpartien.',
      colorCare: 'Nutze Pflege für coloriertes Haar. Wasche möglichst schonend und beachte die Anwendungshinweise deiner Farb- und Pflegeprodukte.',
      antiYellow: 'Nutze pigmentierte Pflege nur entsprechend der Herstellerangabe. Prüfe bei porösem oder sehr hellem Haar zunächst die Wirkung an einer Strähne.',
      curl: 'Verteile die Lockenpflege gleichmäßig und forme deine Wellen oder Locken behutsam. Beginne mit einer kleinen Menge.',
      stylingHold: 'Beginne mit wenig Stylingprodukt und ergänze bei Bedarf. Passe die Menge an Haarlänge und gewünschten Halt an.',
    };
    if (byGoal[answers.goal]) result.push(byGoal[answers.goal]);
    result.push((answers.styling || []).includes('hitzestyling')
      ? 'Verwende vor Föhn oder Glätteisen einen dafür vorgesehenen Hitzeschutz und wähle eine möglichst niedrige, passende Temperatur.'
      : 'Lass dein Haar möglichst schonend trocknen. Ergänze nur so viel Finish, wie du für dein Styling brauchst.');
    return result;
  }
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  function restoreProgress(raw, allowed, now = Date.now()) {
    try {
      if (typeof raw !== 'string' || raw.length > 4096) return null;
      const saved = JSON.parse(raw);
      if (saved?.version !== 1 || !Number.isFinite(saved.at) || saved.at > now || now - saved.at > 30 * 60 * 1000) return null;
      if (!saved.answers || typeof saved.answers !== 'object' || !Number.isInteger(saved.step) || saved.step < 0 || saved.step > 3) return null;
      const values = {};
      for (const name of ['state','treatment','goal','styling']) {
        const entries = name === 'goal' ? [saved.answers[name]] : saved.answers[name];
        if (!Array.isArray(entries) || entries.some(value => typeof value !== 'string' || !allowed[name]?.includes(value))) return null;
        values[name] = name === 'goal' ? entries[0] : [...new Set(entries)];
      }
      const complete = Object.values(values).every(value => Array.isArray(value) ? value.length > 0 : Boolean(value));
      return { answers:values, step:saved.step, result:saved.result === true && complete };
    } catch { return null; }
  }
  global.DRKALLA_HAIR_GUIDE = { productGroups, rankProducts, safeUrl, routine, productRole, selectProducts, resultSummary, restoreProgress };
  if (!global.document) return;

  function init(root) {
    if (root.dataset.hairReady) return;
    root.dataset.hairReady = 'true';
    const find = (name) => root.querySelector(`[data-hair-${name}]`);
    const form = find('form');
    const steps = [...root.querySelectorAll('[data-hair-step]')];
    const result = find('result');
    let step = 0;
    let version = 0;
    let photoUrl = null;
    let photoVersion = 0;
    let resumeResults = false;
    const requests = new Set();
    let started = false;
    const progressKey = 'drkalla-hair-guide-progress-v1';
    const track = (event, fields = {}) => {
      if (global.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(global.dataLayer)) {
        global.dataLayer.push({ event, ...fields });
      }
    };
    const engage = () => { root.dataset.hairEngaged = 'true'; };
    root.addEventListener('pointerdown',engage,{once:true});
    root.addEventListener('focusin',engage,{once:true});
    const reducedMotion = () => global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const summary = find('summary');
    if (summary && global.matchMedia('(max-width:700px)').matches) summary.open = false;
    function answers() {
      const selected = (name) => [...form.querySelectorAll(`input[name="${name}"]:checked`)].map((input) => input.value);
      return { state: selected('state'), treatment: selected('treatment'), goal: selected('goal')[0] || '', styling: selected('styling') };
    }
    function saveProgress() {
      // Only selected answer IDs, never photos, prices, or contact details.
      try {
        const values = answers();
        if (!Object.values(values).some(value => Array.isArray(value) ? value.length : value)) global.sessionStorage.removeItem(progressKey);
        else global.sessionStorage.setItem(progressKey, JSON.stringify({version:1, at:Date.now(), answers:values, step, result:!result.hidden}));
      } catch { /* The questionnaire also works when browser storage is unavailable. */ }
    }
    function updateAnswers() {
      const values = answers();
      ['state','treatment','goal','styling'].forEach((name, index) => {
        const selected = [values[name]].flat().filter(Boolean);
        find('answers').children[index].querySelector('small').textContent = selected.map((value) => labels[value]).join(', ') || 'Noch offen';
      });
      const count = ['state','treatment','goal','styling'].filter(name => [values[name]].flat().some(Boolean)).length;
      if (find('answer-count')) find('answer-count').textContent = `${count} von 4 beantwortet`;
    }
    function showStep(index, focus = false) {
      step = Math.min(Math.max(index, 0), steps.length - 1);
      steps.forEach((element, i) => { element.hidden = i !== step; });
      find('step-count').textContent = `Frage ${step + 1} von ${steps.length}`;
      find('step-name').textContent = steps[step].dataset.title;
      find('progress').style.width = `${(step + 1) / steps.length * 100}%`;
      find('back').hidden = step === 0;
      find('next').textContent = step === steps.length - 1 ? 'Ergebnis ansehen' : 'Weiter';
      find('error').hidden = true;
      saveProgress();
      if (focus) {
        steps[step].querySelector('legend').focus({ preventScroll: true });
        find('questions').scrollIntoView({ behavior: reducedMotion() ? 'instant' : 'smooth', block: 'start' });
      }
    }
    function cancelRequests() {
      version += 1;
      requests.forEach((controller) => controller.abort());
      requests.clear();
    }
    async function hydrate(product) {
      let path = safeUrl(product.url);
      if (!path) return null;
      const controller = new AbortController();
      requests.add(controller);
      const timeout = global.setTimeout(() => controller.abort(), 6000);
      try {
        const options = { signal:controller.signal, credentials:'same-origin', mode:'same-origin' };
        let response = await fetch(`${path.replace(/\/$/, '')}.js`, { ...options, headers:{ Accept:'application/json' } });
        if (response.status === 404) {
          // Shopify product redirects do not always apply to the Ajax .js endpoint.
          const destination = await fetch(path, options);
          const resolved = new URL(destination.url);
          await destination.body?.cancel();
          const redirectedPath = safeUrl(resolved.pathname);
          if (!destination.ok || resolved.origin !== global.location.origin || !redirectedPath || redirectedPath === path) return null;
          path = redirectedPath;
          response = await fetch(`${path.replace(/\/$/, '')}.js`, { ...options, headers:{ Accept:'application/json' } });
        }
        if (!response.ok) return null;
        const live = await response.json();
        if (live.available !== true || !Number.isFinite(live.price) || live.price < 0) return null;
        // Grundpreis of the variant behind the shown (lowest) price.
        const variants = Array.isArray(live.variants) ? live.variants : [];
        const shown = variants.find((variant) => variant.available && variant.price === live.price) || variants.find((variant) => variant.available) || null;
        const measurement = shown?.unit_price_measurement;
        const unitPrice = Number.isFinite(shown?.unit_price) && measurement?.reference_unit
          ? { amount:shown.unit_price / 100, reference:`${Number(measurement.reference_value) > 1 ? `${measurement.reference_value} ` : ''}${measurement.reference_unit}` }
          : null;
        return { ...product, url:path, title:live.title, minPrice:live.price / 100, priceVaries:live.price_varies === true, available:true,
          unitPrice, taxable:shown ? shown.taxable !== false : true,
          image: typeof live.featured_image === 'string' ? live.featured_image : live.featured_image?.src || live.images?.[0] };
      } catch { return null; }
      finally { global.clearTimeout(timeout); requests.delete(controller); }
    }
    function card(product, goal) {
      // The title follows as text, so the image is decorative here.
      const image = typeof product.image === 'string' && /^(https:\/\/|\/\/)/.test(product.image)
        ? `<img src="${escape(product.image)}" alt="" width="300" height="300" loading="lazy">` : '';
      const currency = global.Shopify?.currency?.active || 'EUR';
      const money = (amount) => new Intl.NumberFormat('de-DE', { style:'currency', currency }).format(amount);
      const tax = product.taxable === false ? 'zzgl. Versand' : `inkl. ${currency === 'EUR' ? '19 % ' : ''}MwSt., zzgl. Versand`;
      const unit = product.unitPrice ? `<small class="dk-hair-guide__unit">Grundpreis ${escape(money(product.unitPrice.amount))} / ${escape(product.unitPrice.reference)}</small>` : '';
      return `<a class="dk-hair-guide__product" href="${escape(product.url)}">${image}<strong>${escape(product.title)}</strong><small>${escape(productRole(product))} · ${escape(labels[goal])}</small><span>${product.priceVaries ? 'Ab ' : ''}${escape(money(product.minPrice))}</span>${unit}<small class="dk-hair-guide__tax">${escape(tax)}</small><span>Produkt ansehen</span></a>`;
    }
    async function heatProtectionPick(chosen) {
      // Heat stylers are told to use heat protection; show one that is in stock.
      const taken = new Set(chosen.map((product) => product.url));
      const pool = (global.DRKALLA_HAIR_ANALYSIS?.products || [])
        .filter((product) => productGroups(product).includes('heatProtection') && !taken.has(product.url))
        .sort((a, b) => Number(Array.isArray(b.strong) && b.strong.includes('heatProtection')) - Number(Array.isArray(a.strong) && a.strong.includes('heatProtection')) || rankOf(a) - rankOf(b));
      for (const product of pool.slice(0, 4)) {
        const live = await hydrate(product);
        if (live) return { ...live, role:'Hitzeschutz' };
      }
      return null;
    }
    async function recommend({ restoring = false } = {}) {
      const values = answers();
      cancelRequests();
      const currentVersion = version;
      find('questions').hidden = true;
      result.hidden = false;
      saveProgress();
      find('result-title').textContent = `Dein Fokus: ${labels[values.goal]}`;
      find('result-summary').textContent = resultSummary(values);
      find('routine').innerHTML = routine(values).map((line) => `<li>${escape(line)}</li>`).join('');
      find('products').innerHTML = '';
      find('products').setAttribute('aria-busy','true');
      find('product-status').textContent = 'Wir prüfen passende Produkte, Preise und Verfügbarkeit …';
      if (!restoring) {
        result.scrollIntoView({behavior:reducedMotion() ? 'instant' : 'smooth',block:'start'});
        find('result-title').focus({preventScroll:true});
      }
      let unique = [];
      let heat = null;
      try {
        const ranked = rankProducts(global.DRKALLA_HAIR_ANALYSIS?.products || [], values);
        const candidates = selectProducts(ranked, ranked.length);
        const available = [];
        for (let i = 0; i < candidates.length && available.length < 3; i += 4) {
          const batch = await Promise.all(candidates.slice(i, i + 4).map(hydrate));
          if (currentVersion !== version) return;
          available.push(...rankProducts(batch.filter(Boolean), values));
        }
        if (currentVersion !== version) return;
        unique = selectProducts(available);
        if ((values.styling || []).includes('hitzestyling') && !unique.some((product) => productRole(product) === 'Hitzeschutz')) {
          heat = await heatProtectionPick(unique);
          if (currentVersion !== version) return;
        }
      } catch {
        // Never leave the status on "Wir prüfen …"; fall back to the advice text.
        if (currentVersion !== version) return;
        unique = [];
        heat = null;
      }
      const cards = unique.map((product) => card(product,values.goal));
      if (heat) cards.push(card(heat,'hitzestyling'));
      find('products').dataset.count = String(cards.length);
      find('products').innerHTML = cards.join('');
      find('products').removeAttribute('aria-busy');
      find('product-status').textContent = unique.length
        ? 'Verfügbarkeit geprüft. Varianten und Anwendung findest du beim Produkt.'
        : 'Aktuell konnten wir kein passendes verfügbares Produkt bestätigen. Unsere persönliche Beratung hilft dir gerne bei der Auswahl.';
      if (!restoring) track('drkalla_hair_analysis_completed', { product_count:cards.length });
    }
    form.addEventListener('submit',(event) => {
      event.preventDefault();
      if (!steps[step].querySelector('input:checked')) {
        find('error').textContent = 'Bitte wähle eine Antwort aus, damit wir deine Routine passend zusammenstellen können.';
        find('error').hidden = false;
        steps[step].querySelector('input').focus();
        return;
      }
      track('drkalla_hair_analysis_step_completed', { step:step + 1 });
      if (step < steps.length - 1) showStep(step + 1, true);
      else void recommend();
    });
    form.addEventListener('change',(event) => {
      const input = event.target;
      if (!input.matches('input')) return;
      if (!started) { started = true; track('drkalla_hair_analysis_started'); }
      if (input.checked) {
        const exclusive = { state:['normal'], treatment:['natur','unsicher'], styling:['wenig'] };
        const exclusions = exclusive[input.name] || [];
        form.querySelectorAll(`input[name="${input.name}"]`).forEach((other) => {
          if (other !== input && (exclusions.includes(input.value) || exclusions.includes(other.value))) other.checked = false;
        });
      }
      find('error').hidden = true;
      updateAnswers();
      saveProgress();
    });
    find('products').addEventListener('click', event => {
      const link = event.target.closest('a.dk-hair-guide__product');
      if (link) track('drkalla_hair_analysis_product_clicked', { position:[...find('products').children].indexOf(link) + 1 });
    });
    find('back').addEventListener('click',() => showStep(step - 1,true));
    find('edit').addEventListener('click',() => {
      cancelRequests(); result.hidden = true; find('questions').hidden = false; showStep(0,true);
    });
    function removePhoto() {
      photoVersion += 1;
      if (photoUrl) URL.revokeObjectURL(photoUrl);
      photoUrl = null;
      find('preview').removeAttribute('src');
      find('preview').hidden = true;
      find('photo').value = '';
      find('remove-photo').hidden = true;
      find('photo-status').textContent = 'JPG, PNG oder WebP, bis 5 MB.';
    }
    find('reset').addEventListener('click',() => {
      cancelRequests(); form.reset(); removePhoto(); updateAnswers(); result.hidden = true; started = false;
      find('questions').hidden = false; showStep(0,true);
    });
    find('remove-photo').addEventListener('click',removePhoto);
    find('photo').addEventListener('change',async (event) => {
      const file = event.target.files?.[0];
      if (!file) return;
      const currentPhoto = ++photoVersion;
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 5 * 1024 * 1024) {
        find('photo-status').textContent = 'Bitte wähle ein JPG-, PNG- oder WebP-Bild mit höchstens 5 MB.';
        event.target.value = ''; return;
      }
      const nextUrl = URL.createObjectURL(file);
      try {
        const probe = new Image(); probe.src = nextUrl; await probe.decode();
        if (currentPhoto !== photoVersion) { URL.revokeObjectURL(nextUrl); return; }
        if (photoUrl) URL.revokeObjectURL(photoUrl);
        photoUrl = nextUrl;
        find('preview').src = photoUrl; find('preview').hidden = false;
        find('remove-photo').hidden = false;
        find('photo-status').textContent = 'Foto nur auf diesem Gerät angezeigt. Es wird nicht ausgewertet oder hochgeladen.';
      } catch {
        URL.revokeObjectURL(nextUrl);
        if (currentPhoto === photoVersion) find('photo-status').textContent = 'Das Bild konnte nicht geöffnet werden. Bitte wähle eine andere Datei.';
      }
    });
    global.addEventListener('pagehide',() => {
      resumeResults = !result.hidden;
      saveProgress();
      cancelRequests(); removePhoto();
    });
    global.addEventListener('pageshow',(event) => {
      if (event.persisted && resumeResults && !result.hidden) {
        resumeResults = false;
        void recommend({restoring:true});
      }
    });
    let saved;
    try {
      const allowed = Object.fromEntries(['state','treatment','goal','styling'].map(name =>
        [name, [...form.querySelectorAll(`input[name="${name}"]`)].map(input => input.value).concat(name === 'goal' ? [''] : [])]));
      saved = restoreProgress(global.sessionStorage.getItem(progressKey), allowed);
    } catch { saved = null; }
    if (saved) {
      for (const input of form.querySelectorAll('input[type="checkbox"],input[type="radio"]')) {
        input.checked = [saved.answers[input.name]].flat().includes(input.value);
      }
      started = true;
      updateAnswers();
    }
    showStep(saved?.step || 0);
    if (saved?.result) void recommend({restoring:true});
  }
  function initialize() { global.document.querySelectorAll('[data-hair-guide]').forEach(init); }
  if (global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  global.document.addEventListener('shopify:section:load',initialize);
})(typeof window !== 'undefined' ? window : globalThis);
